var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4",
    "data-name": 4,
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.03,
    height: 20.234,
    viewBox: "0 0 40.03 20.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56577",
    "data-name": "Group 56577",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49854",
    "data-name": "Path 49854",
    d: "M74.643,49.292l.307,7.1c-6.7,6.824-18.761,6.09-24.33.215l-.03-6.949,11.537,4.835,12.518-5.2h0Z",
    transform: "translate(-42.111 -41.029)",
    fill: "#2f7610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49855",
    "data-name": "Path 49855",
    d: "M0,6.979,20.014,0,40.03,6.979,20.014,13.956Z",
    fill: "#3fa214",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49856",
    "data-name": "Path 49856",
    d: "M45.189,26.526,31.725,30.168a.214.214,0,0,0-.184.245l-.06,6a1.189,1.189,0,0,1,.736,1.133,1.134,1.134,0,1,1-2.266,0,1.207,1.207,0,0,1,.674-1.1l.092-6.55a.4.4,0,0,1,.307-.459L44.672,25.79c.489-.153.979.4.521.734h0Z",
    transform: "translate(-24.931 -21.446)",
    fill: "#ff7058",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapGreen);
export default __webpack_public_path__ + "static/media/cap-green.9180b03953739a51ba4f763659990c78.svg";
export { ForwardRef as ReactComponent };